module.exports = __webpack_public_path__ + "img/antes_despues_86.98ebff98.png";